export class EuiMenuItem {
    id?: string;
    label?: string;
    url?: string;
    urlExternal?: string;
    link?: boolean = false;
    iconClass?: string;
    iconTypeClass?: string;
    iconLabel?: string;
    expanded?: boolean = false;
    active?: boolean = false;
    children?: EuiMenuItem[];
    visible?: boolean = true;
    tagLabel?: string;
    tagTypeClass?: string;
    hasMarker?: boolean;
    markerTypeClass?: string;
    category?: string;
    disabled?: boolean;
    filtered?: boolean = true;
    command?: () => void;

    constructor(values: Object = {}) {
        Object.assign(this, values);
    }
}
